module.exports = __webpack_public_path__ + "static/media/Retail.89e71259.jpg";